import { useCallback } from 'react';
import debounce from 'lodash.debounce';

const useDebounce = (callback, deps = [], timeout = 500) => {

  const debounceFn = 
  // debounce(callback, 500) 
  useCallback(debounce(callback, timeout, {
  }), [])
  return {
    debounceFn
  }

}

export default useDebounce;